import { CustomLayout } from '../../base_device'
import list_icon from '@/assets/img/device/mu68/list_icon_pro.png'
import { Mu68 } from './mu68'
import { EffectIndex, KK } from '@/define/define'
import { LightEffectMode, LightEffectModeType } from '@/define/light'
import { LIGHT_EFFECT_LIST_PRO } from '../../light/light_effect_list'
export class Mu68Pro extends Mu68 {
  name: string = 'MU68_PRO'
  icon: string = list_icon
  width: number = 656
  lightEffectList: { [name: LightEffectModeType]: EffectIndex } = LIGHT_EFFECT_LIST_PRO

  inoperableKeys: KK[] = [0x01]
  fnDisableKeys: KK[] = [0x29, 0x1e, 0x1f, 0x20, 0x21, 0x22, 0x23, 0x24, 0x25, 0x26, 0x27, 0x2d, 0x2e, 0x30, 0x2f, 0x13, 0x33, 0x34, 0x16, 0xe3, 0x49, 0x4c, 0x4b, 0x52, 0x50, 0x51, 0x4f, 0x2c, 0xe4, 0x04]
  customLayout: CustomLayout = {
    0x2a: this.createSquare(2, 2, 78),
    0x2b: this.createSquare(2, 2, 58),
    0x31: this.createSquare(2, 2, 58),
    0x39: this.createSquare(2, 2, 82),
    0x28: this.createSquare(2, 2, 74),
    0xe1: this.createSquare(2, 2, 98),
    0xe5: this.createSquare(2, 2, 58),
    0xe0: this.createSquare(2, 2, 52),
    0xe2: this.createSquare(2, 2, 52),
    0xe3: this.createSquare(2, 2, 52),
    0x2c: this.createSquare(2, 2, 236),
  }
  rate: number[] = [8, 4, 2, 1, 0.5, 0.25, 0.125]
  superResponse: boolean = true
}
